import { Box, IconButton } from "@mui/material"
import Icon from "src/@core/components/icon"
import { Settings } from "src/@core/context/settingsContext"
import { HeaderDesktopNuevo } from "./desktop/HeaderDesktopNuevo"
import { HeaderMobileNuevo } from "./mobile/HeaderMobileNuevo"

interface Props {
    isSmallScreen: boolean
    settings: Settings
    toggleNavVisibility: () => void
    codSistema: number
    codSistemaPrincipal: number
    codSistemaTipo: number
    acciones: {
        saveHandler?: () => void
        sendHandler?: () => void
        closeHandler?: () => void
    }
}

const HeaderContent = ({ isSmallScreen, acciones, codSistema, codSistemaPrincipal, codSistemaTipo }: Props) => {

    return (
        <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            {
                isSmallScreen ?
                    <HeaderMobileNuevo codSistema={codSistema} codSistemaPrincipal={codSistemaPrincipal} codSistemaTipo={codSistemaTipo} acciones={acciones} /> :
                    <HeaderDesktopNuevo codSistema={codSistema} codSistemaPrincipal={codSistemaPrincipal} codSistemaTipo={codSistemaTipo} acciones={acciones} />
            }
        </Box>
    )
}

export type HeaderNuevoProps = {
    codSistemaPrincipal: number
    codSistema: number
    codSistemaTipo: number
    acciones: {
        saveHandler?: () => void
        sendHandler?: () => void
        closeHandler?: () => void
    }
}

export default HeaderContent
